import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./parts/header";
import { Sidebar, SidebarWithBackdrop } from "./parts/sidebar";
import { fetchCategories } from "../../../services/api/categories/categories";
import { setCategories } from "../../../redux/features/categoriesSlice";
import "../../../assets/main-layout.css";
import { fetchCompaniesByCityState } from "../../../services/api/company/company";
import { setCompanies } from "../../../redux/features/companiesSlice";

const MainLayout = ({ children, inner, title }) => {
	const mobileScreen = useSelector((state) => state.mediaQuery.mobileScreen);
	const navbarExpanded = useSelector((state) => state.navbar.expanded);
	const { companies } = useSelector((state) => state.companies);
	const business = useSelector(({ auth }) => auth.business);
	const { type } = business
	const dispatch = useDispatch();

	useEffect(() => {
		const loadCategories = async () => {
			try {
				const res = await fetchCategories();
				dispatch(setCategories(res));
			} catch (error) {
				console.error("Error al obtener categorías:", error);
			}
		};
		loadCategories();
	}, [dispatch]);

	useEffect(() => {
		if (
			business &&
			(business.type === "partner" ||
				business.type === "deliveries-provider") &&
			companies.length === 0
		) {
			const loadCompanies = async () => {
				try {
					const res = await fetchCompaniesByCityState(
						business.city,
						business.state
					);
					dispatch(setCompanies(res));
				} catch (error) {
					console.error("Error al obtener empresas:", error);
				}
			};
			loadCompanies();
		}
	}, [business, companies, dispatch]);

	const contentClassName = useMemo(() => {
		return `main-layout-content w-full min-h-screen mt-[70px] p-[32px] sm:p-4 overflow-auto !pb-[100px] ${
			!mobileScreen && navbarExpanded ? "content-expanded" : ""
		}`;
	}, [mobileScreen, navbarExpanded]);

	return (
		<div className="main-layout-container w-screen h-screen flex flex-row overflow-hidden z-[1] pb-[100px]">
			{mobileScreen ? (
				<SidebarWithBackdrop business={business} type={type} />
			) : (
				<Sidebar business={business} type={type} />
			)}
			<Header inner={inner} title={title} business={business} type={type} />
			<div className={contentClassName}>
				{type === "company" && business && business.open === false && (
					<div className="flex w-full bg-[#d9534f] rounded-lg mb-8">
						<p className="text-lg font-bold text-white p-4">
							Tu negocio se encuentra cerrado. No podrás recibir pedidos hasta
							que actualices su estado.
						</p>
					</div>
				)}
				{children}
			</div>
		</div>
	);
};

export default MainLayout;
